import { Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useCartStore } from 'stores/useCartStore';

type CartProps = {
  title?: string;
  description?: string;
  children: React.ReactNode;
};

export default function Cart({ children }: CartProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isOpen = useCartStore((state) => state.isOpen);
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        unmount={false}
        onClose={() => useCartStore.setState({ isOpen: false })}
        className="fixed z-[500] inset-0 right-0 bg-black bg-opacity-30 overflow-y-auto"
        onClick={(e) => {
          // check if the click was outside the dialog
          if (ref.current && !ref.current.contains(e.target as Node)) {
            useCartStore.setState({ isOpen: false });
          }
        }}
      >
        <div className="inset-0 min-h-screen">
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-in duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-30"
            entered="opacity-30"
            leave="transition-opacity ease-out duration-300"
            leaveFrom="opacity-30"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="inset-0 bg-onyx" />
          </Transition.Child>
          <div className="fixed inset-y-0 right-0 md:w-[25rem] max-w-full flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
              ref={ref}
            >
              <div
                className="flex flex-col justify-between bg-onyx z-20
                          w-full max-w-md overflow-y-auto text-left
                          align-middle shadow-xl relative"
              >
                <Dialog.Description className="h-full">
                  {children}
                </Dialog.Description>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
